import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { CHECK_LOGIN_KEY } from '_api/queries';
import { Admin, AdminPayload } from '_api/types';

import { GET_USER_KEY } from '../../queries/user/useGetUserById';

export const UPDATE_ADMIN_KEY = 'update-admin';

export const useUpdateAdmin = () => {
  const queryClient = useQueryClient();
  return useApiMutation<Admin, AdminPayload>(
    () => '/user/update-admin',
    'put',
    {},
    {
      mutationKey: [UPDATE_ADMIN_KEY],
      onSuccess: (data, body: AdminPayload) => {
        const me = queryClient.getQueryData<Admin>([CHECK_LOGIN_KEY]);
        if (body.id) {
          queryClient.invalidateQueries({ queryKey: [GET_USER_KEY] });
        }
        if (me && body.id === me.id) {
          queryClient.invalidateQueries({ queryKey: [CHECK_LOGIN_KEY] });
        }
      },
    },
  );
};
